import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import { languageHelper } from "../../../../config/helperFunctions";



function VatReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "date",
    },
    {
      header: languageHelper("Subtotal") || "Subtotal",
      cell: (row) => row.row.original.sub_total.toFixed(2),
    },
    {
      header: languageHelper("Vat") || "Vat",
      cell: (row) => row.row.original.vat_amount.toFixed(2),
    },
    {
      header: languageHelper("Total Sale") || "Total Sale",
      cell: (row) => row.row.original.sub_total_with_vat.toFixed(2),
    },
  ];
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error, setError] = useState(false);

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const footerConfig = {
    [languageHelper("SN")]: languageHelper("Total") || "Total",
    [languageHelper("Subtotal")]: (rows) =>
      rows.reduce((acc, row) => acc + (row.sub_total || 0), 0).toFixed(2),
    [languageHelper("Vat")]: (rows) =>
      rows.reduce((acc, row) => acc + (row.vat_amount || 0), 0).toFixed(2),
    [languageHelper("Total Sale")]: (rows) =>
      rows.reduce((acc, row) => acc + (row.sub_total_with_vat || 0), 0).toFixed(2),
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/vat-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => { });
  }, [endDate, selectedOutlet, startDate, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Vat Report") || "Vat Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default VatReport;
